<template>
  <header>
    <h1 v-if="!isLoggedIn" class="center-align">
      <router-link :to="{ name: 'home' }">
        <img class="logo" src="https://mfind-production.s3.eu-central-1.amazonaws.com/images/punkta_white.png" alt="punkta">
      </router-link>
    </h1>
    <nav v-if="isLoggedIn">
      <div class="nav-wrapper">
        <router-link :to="{ name: 'dashboard' }">
          <img class="logo" src="https://mfind-production.s3.eu-central-1.amazonaws.com/images/punkta_white.png" alt="punkta">
        </router-link>
        <div class="menu-links hide-on-med-and-down">
          <router-link v-for="link in navLinks" :key="link.routerName"
            :to="{ name: link.routerName }" active-class="active" exact>
            {{ link.name }}
          </router-link>
        </div>
        <div class="menu-right">
          <div class="money-and-share-link left" v-if="showSpecialToolsLink">
            <money-info class="left" />
            <router-link :to="{ name: 'tools' }" class="btn">NARZĘDZIA</router-link>
          </div>
          <a class="btn btn-overlay btn-logout hide-on-med-and-down" @click="logout">Wyloguj</a>
          <a href="#" data-activates="slide-out-nav" class="button-collapse right show-on-medium-and-down">
            <i class="mfind-icon-menu"></i>
          </a>
        </div>
      </div>
    </nav>
    <ul id="slide-out-nav" class="slide-nav fixed right hide-on-large-only show-on-medium-and-down" v-if="isLoggedIn">
      <li class="no-divider">
        <a class="btn btn-overlay btn-logout" @click="logout">Wyloguj</a>
        <a href="#" class="right"><i class="mfind-icon-close"></i></a>
      </li>
      <li class="money-container no-divider" v-if="showSpecialToolsLink">
        <money-info class="left" />
        <router-link :to="{ name: 'tools' }" class="btn right">NARZĘDZIA</router-link>
      </li>
      <li class="no-divider">
        <div class="card">
          <user-info />
        </div>
      </li>
      <li v-for="link in navLinks">
        <router-link :to="{ name: link.routerName }" active-class="active" exact>
          {{ link.name }}
        </router-link>
      </li>
      <li class="no-divider">
        <contact/>
      </li>
      <li class="no-divider">
        <find-us/>
      </li>
    </ul>
  </header>
</template>

<script>
import jQuery from 'jquery'
import MoneyInfo from '@/components/moneyInfo'
import FindUs from '@/components/findUs'
import Contact from '@/components/contact'
import UserInfo from '@/components/userInfo'
import { userHasAnyOfRoles, userHasRole } from '@/services/helper'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: { UserInfo, FindUs, Contact, MoneyInfo },
  methods: {
    ...mapActions(['logout']),
    destroyNav () {
      jQuery('.menu-right .button-collapse').sideNav('destroy')
    },
    updateNav () {
      jQuery('.menu-right .button-collapse').sideNav({
        edge: 'right',
        closeOnClick: true,
        draggable: true,
        onOpen: (el) => { el.addClass('open') },
        onClose: (el) => { el.removeClass('open') }
      })
    }
  },
  computed: {
    // mix the getters into the computed object
    ...mapGetters([
      'isLoggedIn', 'getUserRoles'
    ]),
    navLinks () {
      let navLinks = []
      switch (true) {
        case userHasRole(this.getUserRoles, 'agent'):
          navLinks = [ { name: 'NARZĘDZIA', routerName: 'tools' } ]
          break
        case userHasRole(this.getUserRoles, 'admin'):
          navLinks = [ { name: 'STATYSTYKI PARTNERÓW', routerName: 'users' } ]
          // falls through
        case userHasRole(this.getUserRoles, 'accountant'):
          navLinks = [...navLinks,
            { name: 'TRANSZE', routerName: 'tranches' },
            { name: 'MAILE', routerName: 'mails' },
            { name: 'PEŁNY PROCES', routerName: 'completeProcess' }
          ]
          break
        case userHasRole(this.getUserRoles, 'agent_level2'):
          navLinks = [
            { name: 'NARZĘDZIA', routerName: 'tools' }
          ]
          break
        default:
          navLinks = [
            { name: 'NARZĘDZIA', routerName: 'tools' },
            { name: 'TWOJE ŚRODKI', routerName: 'yourFunds' }
          ]
      }
      return navLinks
    },
    showSpecialToolsLink () {
      if (userHasAnyOfRoles(this.getUserRoles, ['agent', 'agent_level2'])) {
        return false
      }

      return !userHasAnyOfRoles(this.getUserRoles, ['accountant', 'admin'])
    }
  },
  updated () {
    this.destroyNav()
    if (this.isLoggedIn) {
      this.updateNav()
    }
  },
  mounted () {
    this.destroyNav()
    if (this.isLoggedIn) {
      this.updateNav()
    }
  }
}
</script>

<style lang="scss" src="./headerBar.scss"></style>



// WEBPACK FOOTER //
// headerBar.vue?c49e38da